export const DATA_HOST = process.env.REACT_APP_DATA_HOST
export const REST_DATA_URL = '/rest/v1/ccards'
export const REST_FILE_URL = '/rest/v1/uploadFile'
export const AUTH_HOST = process.env.REACT_APP_AUTH_HOST

export const AUTH_USER = 'erv_cards_client'
export const AUTH_CREDENTIALS = '@dEc&q$JYzh4ZGMQB%rU4DtMZ^Yywjcn'
export const AUTH_SCOPES = 'authUser:read authUser:register authUser:update'

export const USER_USER = 'erv_cards_user'
export const USER_CREDENTIALS = 'a4jcRk!*Wr65Ra8^EwrHeAbdu*t&km35'
export const USER_SCOPES = 'ccard:read ccard:write'

export const MIN_PASSWORD_SIZE = 8
export const PASSWORD_SPECIAL_CHARS = '+-.,;:_<>@#+*!§$%&/()=?"\''
